import $ = require("jquery");

import l10n from "diy/util/l10n";

import Type from "../definitions/Type";
import {NotificationConfig} from "../definitions/Config";

export default {
    type: Type.SECTIONS_ADD_GROUP,

    testId: "sectionsAddGroupNotification",
    trackingId: "SectionsAddGroupNotification",

    title: "",
    content: l10n("section.welcomeNotification.title"),

    mainAction: {
        testId: "tryIt",
        label: l10n("section.welcomeNotification.linkText"),
        onClick: () => {
            $('#cc-sa-item-sections').click();
        }
    }

} as NotificationConfig;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/toolbar/notificationNG/types/SectionsAddGroup.ts
 **/